// The page's language as <html lang> (vike-react): the one the page renders
// in — its URL prefix, as pages/+onBeforeRender settled it (metadata.language)
export default (pageContext) => pageContext.metadata?.language || pageContext.ssrLanguage || "en"
